import AppShell from "../components/layout/AppShell";
import ExternalSignerPage from "./ExternalSignerPage";

function InternalSignerPage() {
  return (
    <AppShell>
      <ExternalSignerPage />
    </AppShell>
  );
}

export default InternalSignerPage;
